import React from 'react'
import PropTypes from 'prop-types'
import './Card.css'

export const Card = (props) => (
  <div className='Card'>
    {!props.picked && 
      <div className='Card__content Card__back' onClick={props.onClick} data-index={props.index} />}

    {props.picked && 
      <div className={'Card__content Card__' + props.type} />}
  </div>
)

Card.propTypes = {
  index: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  picked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

export default Card



// WEBPACK FOOTER //
// ./src/Card.js